import { render, staticRenderFns } from "./ProfessionTaskCityContent.vue?vue&type=template&id=16a0f35f"
import script from "./ProfessionTaskCityContent.vue?vue&type=script&lang=js"
export * from "./ProfessionTaskCityContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports